import React from 'react';
import Reflux from 'reflux';
import EventViewStore from 'flux/stores/EventViewStore';
import EventShowListStore from 'flux/stores/EventShowListStore';
import GuestCuesheetStore from 'flux/stores/cuesheet.guest/GuestCuesheetStore';
import PDFExportFormActions from 'flux/actions/cuesheet.printable/PDFExportFormActions';
import PDFExportFormStore from 'flux/stores/cuesheet.printable/PDFExportFormStore';
import { Row, Col } from 'bootstrap';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import ShowsMenu from 'shared/components/menus/shows.jsx';
import RouteActions from 'flux/actions/RouteActions';
import DownloadHelper from 'shared/lib/downloadHelper';
import TimeHelper from 'time';
import classnames from 'classnames';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';

export default React.createClass({
  displayName: 'GuestCuesheetPageHeader',

  mixins: [
    Reflux.connect(EventViewStore, 'event'),
    Reflux.connect(GuestCuesheetStore, 'cuesheet'),
    Reflux.connectFilter(EventShowListStore, 'shows', (st) => st.get('shows')),
    Reflux.connect(PDFExportFormStore, 'pdfExport'),
  ],

  render() {
    const { event, cuesheet } = this.state;

    const team = cuesheet.get('team');
    const show = cuesheet.get('show');

    const current = Date.now();
    const twentyFourHourClock = event.get('twentyFourHourClock');

    const globalElementManager = event.get('globalElementManager');

    return (
      <Row
        className={classnames({
          'printable-cuesheet-global-element-header': globalElementManager,
        })}
      >
        <div className="printable-cuesheet-header">
          <Col lg={7} md={8} sm={8} xs={24}>
            <div className="printable-cuesheet-header-subitem">
              {this._getShowNode()}
              <span className="printable-cuesheet-last-updated">
                Last Updated:{' '}
                {TimeHelper.getFormattedTime(current, twentyFourHourClock)}
              </span>
            </div>
          </Col>

          <Col lg={10} md={8} sm={8} xs={24}>
            <div className="printable-cuesheet-header-subitem titles">
              <h5 className="printable-cusheet-team-title">
                {team.get('title')}
              </h5>
              <h4>{event.get('title')}</h4>
              {globalElementManager ? (
                <h5 className="printable-cusheet-show-title">
                  {show.get('title')}
                </h5>
              ) : null}
            </div>
          </Col>

          <Col lg={7} md={8} sm={8} xs={24}>
            <div className="printable-cuesheet-header-subitem">
              {this._getGuestPassFunctionality()}
            </div>
          </Col>
        </div>
        <div className="printable-header-height" />
      </Row>
    );
  },

  _getGuestPassFunctionality() {
    return (
      <div className="printable-cuesheet-action-btns">
        <Icon
          className="printable-cuesheet-update"
          name="refresh"
          onClick={() => window.location.reload()}
        />
        {this._getDownloadButtonNode()}
        <span
          className="printable-cuesheet-login"
          onClick={() => RouteActions.goToLogin()}
        >
          Login
        </span>
      </div>
    );
  },

  _generatePDF() {
    const { event, cuesheet, pdfExport } = this.state;

    const generatingGuestPDFUrl = pdfExport.get('generatingGuestPDFUrl');

    if (generatingGuestPDFUrl) return;

    const show = cuesheet.get('show');
    const team = cuesheet.get('team');

    const guestColumns = cuesheet.get('guestColumns');
    const guestColumnOrder = guestColumns.keySeq().toArray();

    const pdfParams = {
      teamId: team.get('_id'),
      eventId: event.get('_id'),
      showId: show.get('_id'),
      columnOrder: guestColumnOrder,
      showTitle: show.get('title'),
      eventTitle: event.get('title'),
      twentyFourHour: event.get('twentyFourHourClock'),
      timeZone: event.get('timeZone'),
      teamTitle: team.get('title'),
    };

    if (team.get('photo')) {
      pdfParams.teamLogoUrl = team.get('photo');
      pdfParams.displayTeamLogo = true;
    }

    if (event.get('photo')) {
      pdfParams.eventLogoUrl = event.get('photo');
      pdfParams.displayEventLogo = true;
    }

    const pdfConfig = DownloadHelper.getGuestPDFConfig(pdfParams);

    PDFExportFormActions.generateGuestPDF(pdfConfig);
  },

  _getDownloadButtonNode() {
    const { pdfExport } = this.state;
    let guestPDFUrl = pdfExport.get('guestPDFUrl');
    let generatingGuestPDFUrl = pdfExport.get('generatingGuestPDFUrl');

    if (guestPDFUrl) {
      return (
        <WithTooltip placement="top" tip="Click to download" delay={0}>
          <a
            href={guestPDFUrl}
            download
            target="_blank"
            rel="noopener noreferrer"
            className={classnames(
              'printable-cuesheet-pdf-button fa fa-download printable-cuesheet-pdf',
            )}
          />
        </WithTooltip>
      );
    }

    return (
      <WithTooltip
        placement="top"
        delay={0}
        tip={generatingGuestPDFUrl ? 'Generating PDF' : 'Click to generate PDF'}
      >
        <a
          className={classnames(
            'fa fa-download printable-cuesheet-pdf-button',
            { generating: generatingGuestPDFUrl },
          )}
          onClick={this._generatePDF}
        />
      </WithTooltip>
    );
  },

  _getShowNode() {
    const { event, cuesheet, shows } = this.state;

    const team = cuesheet.get('team');
    const show = cuesheet.get('show');
    if (!shows || !shows.size) return show.get('title');

    const teamId = team.get('_id');
    const eventId = event.get('_id');
    const showId = show.get('_id');
    const guestPassShows = shows.filter(
      (guestPassShow) =>
        guestPassShow.get('disableGuestPass') === false &&
        guestPassShow.get('archived') === false,
    );

    return (
      <ShowsMenu
        onChange={(guestPassShow) =>
          RouteActions.goToShowForGuest({
            teamId,
            eventId,
            showId: guestPassShow.get('_id'),
          })
        }
        activeId={showId}
        shows={guestPassShows}
        isGuestPass
      />
    );
  },
});
